var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"pt-10"},[_c('b-row',[_c('b-col',{staticClass:"mt-10 d-flex justify-content-center"},[_c('span',{staticClass:"spinner-border spinner-border-lg"})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }